<template>
  <div>
    <ImportSheetDataModal :sheet="sheet.key" />
    <div class="spreadsheet" ref="spreadsheet">
      <!-- formula editor positioned absolutly -->
      <div class="spreadsheet__valueEditor js-valueEditor" v-show="inputStarted">
        <span
          contenteditable="true"
          ref="inputValue"
          :class="[
            'spreadsheet__valueInput'
          ]"
          @blur="updateData"
          @input="cellValueChange"
          @keypress.enter.prevent="cellValueChange(true)"
          >
        </span>
      </div>
      <b-container fluid>
        <div class="importData">
          <b-button
            variant="primary sm"
            @click="updateSheet"
            >
            Import data
          </b-button>
        </div>
        <div class="sizeCtrl">
          <div class="sizeCtrl__input">
            <b-form-group
              label="Column count:"
              >
              <b-form-input
                type="number"
                :value="columnCount"
                @change="setColumnCount"
                ref="columnCountInupt"
                >
              </b-form-input>
            </b-form-group>
          </div>
          <div class="sizeCtrl__input">
            <b-form-group
              label="Row count:"
              >
              <b-form-input
                type="number"
                placeholder="Row count"
                :value="rowCount"
                @change="setRowCount"
                ref="rowCountInput"
                >
              </b-form-input>
            </b-form-group>
          </div>
        </div>
        <div>reference key: <b>&{{ this.sheet.key }}</b></div>

        <table class="spreadsheet__table">
          <thead>
            <tr>
              <th class="spreadsheet__rowHeader">&nbsp;</th>
              <th v-for="ic in columnCount" :key="'ch'+ ic" class="spreadsheet__columnHeader">
                {{ getColLabel(ic) }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(row, ir) in sheetReflection"
              :key="ir"
              >
              <td class="spreadsheet__rowHeader">{{ +ir + 1 }}</td>
              <td
                v-for="(cell, ic) of row"
                :key="'c' + (ic + 1) + 'r' + (ir + 1)"
                @click="setCurrentCell(ir + 1, ic + 1)"
                :class="[
                  'spreadsheet__cell',
                  {
                    '_selected': currentCell.row === ir + 1 && currentCell.column === ic + 1,
                    '_error': (cellValue(ir + 1, ic + 1) + '').match(/^#ERROR/)
                  }
                ]"
                class="spreadsheet__cell"
                v-html="cellDisplayValue(ir + 1, ic + 1)"
                >
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <virtual-list
          :size="20"
          :remain="10"
          rtag="table"
          wtag="tbody"
          class="spreadsheet__table"
          >

          <template>
            <thead>
              <tr>
                <th class="spreadsheet__rowHeader">&nbsp;</th>
                <th v-for="ic in columnCount" :key="'ch'+ ic" class="spreadsheet__columnHeader">
                  {{ getColLabel(ic) }}
                </th>
              </tr>
            </thead>
          </template>

          <tr
            v-for="(row, ir) in sheetReflection"
            :key="ir"
            >
            <td class="spreadsheet__rowHeader">{{ +ir + 1 }}</td>
            <td
              v-for="(cell, ic) of row"
              :key="'c' + (ic + 1) + 'r' + (ir + 1)"
              @click="setCurrentCell(ir + 1, ic + 1)"
              :class="[
                'spreadsheet__cell',
                {
                  '_selected': currentCell.row === ir + 1 && currentCell.column === ic + 1,
                  '_error': (cellValue(ir + 1, ic + 1) + '').match(/^#ERROR/)
                }
              ]"
              class="spreadsheet__cell"
              v-html="cellDisplayValue(ir + 1, ic + 1)"
              >
            </td>
          </tr>
        </virtual-list> -->
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import ImportSheetDataModal from '@/components/Modals/ImportSheetData'
import VirtualList from 'vue-virtual-scroll-list'
// services
import db from '@/services/db'
// helpsers
import utils from '@/helpers/utils'
import eventBus from '@/helpers/event-bus'

import FormulaProcessor from './FormulaProcessor'

let $ = window.$

export default {
  props: [
    'parentSheet',
    'sheet',
    'scopedData',
    'sheets'
  ],
  components: {
    ImportSheetDataModal,
    VirtualList
  },
  data () {
    return {
      columnCount: this.sheet.columnCount || 7,
      rowCount: this.sheet.rowCount || 10,
      currentCellRange: {
        row: null,
        column: null
      },
      sheetReflection: [],
      valueInput: '',
      inputStarted: false
    }
  },
  computed: {
    ...mapState([
      'localSpreadsheets'
    ]),
    currentCell () {
      let row = this.currentCellRange.row
      let column = this.currentCellRange.column
      let label = this.cellLabel(row, column)

      return {
        row,
        column,
        label
      }
    },
    currentCellValue: {
      get () {
        return this.cellValue(this.currentCell.row, this.currentCell.column)
      },
      set (val) {
        this.$set(this.sheet.data, this.currentCell.label, val)
        if (val === '') {
          delete this.sheet.data[this.currentCell.label]
        }
      }
    }
  },
  methods: {
    getColLabel: utils.getColLabel,
    rowLabel (rowIndex) {
      return rowIndex + ''
    },
    cellLabel (rowIndex, columnIndex) {
      return this.$getColLabel(columnIndex) + this.rowLabel(rowIndex)
    },
    cellValue (rowIndex, columnIndex) {
      let label = this.cellLabel(rowIndex, columnIndex)

      if (this.sheet.data.hasOwnProperty(label)) {
        let val = this.sheet.data[label]
        if (val && val[0] === '=') {
          try {
            let processor = new FormulaProcessor(val, this.scopedData)
            val = processor.start()
          } catch (err) {
            val = '#ERROR: ' + err.message
          }
        }
        return val
      } else {
        return null
      }
    },
    cellDisplayValue (rowIndex, columnIndex) {
      let val = this.cellValue(rowIndex, columnIndex)
      if (val === null) {
        return ''
      } else {
        return val
      }
    },
    setCurrentCell (row, column) {
      this.currentCellRange = { row, column }

      // set formula input position
      setTimeout(() => {
        this.inputStarted = true

        let spreadsheet = $(this.$refs.spreadsheet)
        let input = $(this.$refs.inputValue)
        let cell = spreadsheet.find('.spreadsheet__cell._selected')
        let cellPos = cell.position()
        let val = this.sheet.data[this.currentCell.label] || ''

        val = val.replace(/&!\w+\.[A-Z][0-9]|&!\w+\.\w+\.[A-Z][0-9]/g, (x) => {
          return '&' + x.slice(x.lastIndexOf('.') + 1)
        })
        input.text(val)
        this.valueInput = val
        input.closest('.js-valueEditor').css({
          left: cellPos.left + spreadsheet[0].scrollLeft,
          top: cellPos.top + spreadsheet[0].scrollTop,
          'min-width': cell.outerWidth(),
          'min-height': cell.outerHeight()
        })
        this.$refs.inputValue.focus()
        setTimeout(() => {
          this.$cursorToEnd(this.$refs.inputValue)
        })
      })
    },
    cellValueChange (loseFocus) {
      this.valueInput = $(this.$refs.inputValue).text()
      if (typeof loseFocus === 'boolean' && loseFocus) {
        $(this.$refs.inputValue).blur()
      }
    },
    updateData () {
      this.inputStarted = false
      let vm = this
      let sheet = vm.sheet.key
      let cell = vm.currentCell.label

      let val = (vm.valueInput.trim()).replace(/&[A-Z][0-9]/g, (x) => {
        return '&!' + sheet + '.' + x.slice(1)
      })

      let data = {
        sheet: sheet,
        cell: cell,
        value: val
      }

      this.currentCellValue = val

      if (this.localSpreadsheets[this.parentSheet]) {
        db.sheets.updateLocalSpreadsheetCell(data)
      } else {
        db.sheets.updateCell(data, (err) => {
          if (err) this.$store.commit('addError', err.message)
        })
      }
    },
    setColumnCount () {
      let newCount = parseInt($(this.$refs.columnCountInupt['$el']).val())
      if (newCount <= 200) {
        db.sheets.setColumnCount(this.sheet.key, newCount)
      } else {
        console.log('too much columns')
      }
    },
    setRowCount () {
      let newCount = parseInt($(this.$refs.rowCountInput['$el']).val())
      if (newCount <= 10000) {
        db.sheets.setRowCount(this.sheet.key, newCount)
      } else {
        console.log('too much rows')
      }
    },
    updateSheet () {
      eventBus.$emit('updateSpreadsheet')
    }
  },
  created () {
    for (let ir = 0; ir < this.rowCount; ir++) {
      if (!this.sheetReflection[ir]) this.sheetReflection[ir] = []
      for (let ic = 0; ic < this.columnCount; ic++) {
        this.sheetReflection[ir][ic] = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.spreadsheet {
  position: relative;
  width: 100%;
  height: inherit;
  overflow-y: auto;
  &__value {
    &Editor {
      position: absolute;
      display: flex;
    }
    &Input {
      width: 100%;
      display: inline-block;
      outline: none;
      border: 2px blue solid;
      background: white;
      padding: 0 4px;
    }
  }
  &__columnHeader,
  &__rowHeader,
  &__cell {
    border: 1px solid darkgray;
  }
  &__columnHeader,
  &__rowHeader {
    text-align: center;
  }
  &__columnHeader {
    min-width: 150px;
  }
  &__rowHeader {
    min-width: 40px;
  }
  &__table {
    border-spacing: 0px;
  }
  &__cell {
    padding: 0 5px;
    &._error {
      font-weight: bolder;
      color: darkred;
    }
  }
}
.sizeCtrl {
  @include cf;
  padding: 10px 0;
  &__input {
    @include span(3);
    margin-right: 15px;
  }
}
.importData {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Spreadsheet/Sheet.vue